import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import * as AdDataInfo from '../assets/appsettings.json';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
const windowsOrgin = window.location.origin;
const AdInfo = ( AdDataInfo['default'] && AdDataInfo['default'].hasOwnProperty('AdData') && AdDataInfo['default'].AdData !== null ) ? AdDataInfo['default'].AdData : null;
export const b2cPolicies = {
     names: {
         signUpSignIn: ( AdInfo !== null) ? `${AdInfo.AzureADB2CAuthority}/` : null,
         editProfile: ( AdInfo !== null) ? `${AdInfo.AzureADB2CAuthority}/` : null
     },
     authorities: {
         signUpSignIn: {
             authority: ( AdInfo !== null ) ? `${AdInfo.AzureADB2CAuthority}/` + `${AdInfo.AzureADB2CTenant}/` + `${AdInfo.AzureADB2CUserflow}` : null,
         },
         editProfile: {
             authority: ( AdInfo !== null ) ?  `${AdInfo.AzureADB2CAuthority}/` + `${AdInfo.AzureADB2CTenant}/` + `${AdInfo.AzureADB2CUserflow}` : null
         }
     },
     authorityDomain: ( AdInfo !== null ) ? [AdInfo.AzureADB2CAuthority] : null,
     redirectUri: ( AdInfo !== null ) ? `${windowsOrgin}` : null

 };
 export const CommonAdPolicies = {
    authorities: {
        signUpSignIn: {
            authority: 'https://login.microsoftonline.com/common',
        },
        editProfile: {
            authority: "https://login.microsoftonline.com/common"
        }
    },
    authorityDomain: [],
    redirectUri: `${windowsOrgin}/`
};
 
 
export const msalConfig: Configuration = {
     auth: {
         clientId: ( AdInfo !== null ) ? AdInfo.ClientId : null,
         authority: ( AdInfo !== null && AdInfo.AzureAdType ) ? b2cPolicies.authorities.signUpSignIn.authority : CommonAdPolicies.authorities.signUpSignIn.authority,
         knownAuthorities: ( AdInfo !== null && AdInfo.AzureAdType ) ? b2cPolicies.authorityDomain : CommonAdPolicies.authorityDomain,
         redirectUri: CommonAdPolicies.redirectUri, 
         navigateToLoginRequestUrl: true,
     },
     cache: {
         cacheLocation: BrowserCacheLocation.LocalStorage,
         storeAuthStateInCookie: true, 
     },
     system: {
        allowRedirectInIframe: true,
         loggerOptions: {
            loggerCallback: (logLevel, message, containsPii) => {
                console.log(message);
             },
             logLevel: LogLevel.Verbose,
             piiLoggingEnabled: false,
         }
     }
 }

export const protectedResources = {
  todoListApi: {
    endpoint: "http://localhost:5000/api/todolist",
    scopes: ["openid"],
  },
}
export const loginRequest = {
  scopes: ( AdInfo !== null ) ? ["openid"] : ['openid', 'profile', 'User.Read', 'offline_access'], 
//   redirectUri: ( AdDataInfo['default'].AdData.AzureAdType === '2') ? b2cPolicies.redirectUri : CommonAdPolicies.redirectUri
};

export const TentantInfo = {
    TenantId: ( AdInfo !== null ) ? AdInfo.TenantId : null,
    ClientId: ( AdInfo !== null ) ? AdInfo.ClientId : null,
    ClientSecret: ( AdInfo !== null ) ? AdInfo.ClientSecret : null,
    azureAdType: ( AdInfo !== null ) ? AdInfo.AzureAdType : null,
    azureADB2CAuthority: ( AdInfo !== null ) ? AdInfo.AzureADB2CAuthority : null,
    azureAdB2CUserflow: ( AdInfo !== null ) ? AdInfo.AzureADB2CUserflow : null,
    TenantName: ( AdInfo !== null ) ? AdDataInfo['default'].TenantIdentifier : null
}

export const CheckIsAd = {
    IsEnabledAd: ( AdInfo !== null && AdDataInfo['default'] && AdDataInfo['default'].hasOwnProperty('AdData') && AdInfo !== null && AdInfo.IsAdEnabled) 
}
export const tokenRequest = {
    scopes: ["openid"],
    forceRefresh: false
    };

